// ============= BASE ENUMS =============
/**
 * Defines possible sender roles for commands and events
 */
export var SenderRoleType;
(function (SenderRoleType) {
    SenderRoleType["HOST"] = "HOST";
    SenderRoleType["PLAYER"] = "PLAYER";
    SenderRoleType["AUDIENCE"] = "AUDIENCE";
    SenderRoleType["SYSTEM"] = "SYSTEM";
})(SenderRoleType || (SenderRoleType = {}));
/**
 * Defines possible actions for element management (create, update, remove)
 * Used for player inputs, game elements, and info elements
 */
export var ElementActionType;
(function (ElementActionType) {
    ElementActionType["CREATE"] = "create";
    ElementActionType["UPDATE"] = "update";
    ElementActionType["REMOVE"] = "remove";
})(ElementActionType || (ElementActionType = {}));
// ============= ROOM MANAGEMENT ENUMS =============
/**
 * Defines possible room management actions
 */
export var RoomActionType;
(function (RoomActionType) {
    RoomActionType["CREATE"] = "createRoom";
    RoomActionType["START"] = "startGame";
    RoomActionType["END"] = "endGame";
    RoomActionType["CLOSE"] = "closeRoom";
})(RoomActionType || (RoomActionType = {}));
/**
 * Defines possible player-room interaction actions
 */
export var RoomPlayerActionType;
(function (RoomPlayerActionType) {
    RoomPlayerActionType["JOIN"] = "join";
    RoomPlayerActionType["LEAVE"] = "leave";
    RoomPlayerActionType["KICK"] = "kick";
    RoomPlayerActionType["UPDATE"] = "update";
    RoomPlayerActionType["ELIMINATE"] = "eliminate";
    RoomPlayerActionType["ADD_TO_TEAM"] = "addToTeam";
    RoomPlayerActionType["REMOVE_FROM_TEAM"] = "removeFromTeam";
    RoomPlayerActionType["CHANGE_TEAM"] = "changeTeam";
})(RoomPlayerActionType || (RoomPlayerActionType = {}));
/**
 * Defines possible player update types
 */
export var PlayerUpdateType;
(function (PlayerUpdateType) {
    PlayerUpdateType["NAME"] = "name";
    PlayerUpdateType["COLOR"] = "color";
    PlayerUpdateType["NAME_AND_COLOR"] = "nameAndColor";
})(PlayerUpdateType || (PlayerUpdateType = {}));
/**
 * Defines possible player-room interaction actions
 */
export var RoomTeamActionType;
(function (RoomTeamActionType) {
    RoomTeamActionType["CREATE"] = "createTeam";
    RoomTeamActionType["UPDATE"] = "updateTeam";
    RoomTeamActionType["DISBAND"] = "disbandTeam";
    RoomTeamActionType["ELIMINATE"] = "eliminate";
})(RoomTeamActionType || (RoomTeamActionType = {}));
// ============= GAMEPLAY ENUMS =============
/**
 * Defines possible Game Elements for commands and events
 */
export var GameElementType;
(function (GameElementType) {
    GameElementType["TURN"] = "turn";
    GameElementType["PROMPT"] = "prompt";
    GameElementType["ANSWER"] = "answer";
    GameElementType["VOTE"] = "vote";
})(GameElementType || (GameElementType = {}));
/**
 * Defines possible request types for commands and events
 */
export var InfoElementType;
(function (InfoElementType) {
    InfoElementType["CHOICES"] = "choices";
    InfoElementType["COMMENTARY"] = "commentary";
    InfoElementType["IMAGE_DESCRIPTION"] = "imageDescription";
    InfoElementType["SCORE_MAP"] = "scoreMap";
    InfoElementType["DERIVED_CONTENT"] = "derivedContent";
    // Add more as needed
})(InfoElementType || (InfoElementType = {}));
/**
 * Defines possible media types
 */
export var MediaType;
(function (MediaType) {
    MediaType["SPEECH"] = "speech";
    MediaType["IMAGE"] = "image";
    MediaType["BACKGROUND"] = "background";
    MediaType["MUSIC"] = "music";
    MediaType["SFX"] = "sfx";
})(MediaType || (MediaType = {}));
/**
 * Defines possible media state actions
 */
export var MediaActionType;
(function (MediaActionType) {
    MediaActionType["REQUEST"] = "request";
    MediaActionType["READY"] = "ready";
    MediaActionType["STARTED"] = "started";
    MediaActionType["COMPLETED"] = "completed";
})(MediaActionType || (MediaActionType = {}));
/**
 * Defines possible interaction window actions
 */
export var InteractionWindowActionType;
(function (InteractionWindowActionType) {
    InteractionWindowActionType["OPEN"] = "open";
    InteractionWindowActionType["PAUSE"] = "pause";
    InteractionWindowActionType["RESUME"] = "resume";
    InteractionWindowActionType["CLOSE"] = "close";
    InteractionWindowActionType["WARN"] = "warn";
})(InteractionWindowActionType || (InteractionWindowActionType = {}));
// ============= QUERY ENUMS =============
/**
 * Defines the types of queries clients can make.
 */
export var QueryType;
(function (QueryType) {
    QueryType["STATE_SYNC"] = "STATE_SYNC";
})(QueryType || (QueryType = {}));
//# sourceMappingURL=enums.js.map